export const getReviewButtonProps = (item) => {
  let icon = "mdi:file-document-edit-outline";
  let color = "#f8bb86"; // pending
  let title = "Run AI Review";
  let disabled = false;

  // Published → read-only
  if (item.status === "published") {
    icon = "mdi:file-document-check-outline";
    color = "#2196f3";
    title = "Published";
    disabled = true;
  } 
  // Draft / Pending review → editing allowed
  else if (["draft", "pending_review"].includes(item.status)) {
    icon = "mdi:file-document-edit-outline";
    color = "#9e9e9e";
    title = "Edit Draft";
    disabled = false;
  } 
  // AI Approved / QA approved
  else if (item.reviewStatus === "approved" || item.status === "ai_approved") {
    icon = "mdi:file-document-check-outline";
    color = "#4caf50";
    title = "AI Review Done";
    disabled = false; // allow Override & Re-run
  } 
  // AI Rejected / QA rejected
  else if (item.reviewStatus === "rejected" || item.status === "ai_rejected") {
    icon = "mdi:file-document-remove-outline";
    color = "#f44336";
    title = "AI Rejected - Edit Needed";
    disabled = false;
  } 
  // Pending AI review
  else if (item.reviewStatus === "pending" || item.status === "pending_ai_review") {
    icon = "mdi:file-document-edit-outline";
    color = "#ff9800";
    title = "Run AI Review";
    disabled = false;
  }

  return { icon, color, title, disabled };
};
